import * as React from 'react';
import { connect } from '../../utils/redux/connect';
import { IApplicationState, TDispatch } from '../../types/redux';
import { getSuitableBuildingType } from '../../components/search_filters/filters/helpers';
import { TypeFilter as TypeFilterInput } from '../../components/search_filters/filters/type_filter';
import { updateBuildingType } from '../../reducers/modules/search/building_types';
import { setDirty, setSearchType } from '../../reducers/modules/search/type';
import { clearCommercialGeo } from '../../reducers/modules/search/user_geo';
import { GenericFilter } from './generic_filter';
import { ISearchType, SearchType } from '../../types/filters/type';
import { IBuildingTypesConfig } from '../../types/filters/building_types';
import { ISearchConfig } from '../../types/search';

interface IStoreProps {
  type: ISearchType;
  buildingType: string[];
}

interface IDispatchProps {
  onClearCommercialGeo(): void;
  setDirty(isDirty: boolean): void;
  setSearchType(searchType: string): void;
  updateBuildingType(buildingType: string[]): void;
}

interface IOwnProps {
  buildingTypes: IBuildingTypesConfig;
  searchConfig: ISearchConfig;
}

interface IProps extends IStoreProps, IDispatchProps, IOwnProps {}
interface IState {}

class TypeFilterClass extends GenericFilter<IProps, IState> {
  protected setDirty(isDirty: boolean) {
    this.props.setDirty(isDirty);
  }

  public render() {
    return <TypeFilterInput value={this.props.type.searchType} onChange={this.hendlerOnChange} />;
  }

  private hendlerOnChange = (type: string) => {
    const { setSearchType, onClearCommercialGeo, updateBuildingType, buildingType, buildingTypes, searchConfig } =
      this.props;

    setSearchType(type);

    if (type === 'rent_short') {
      onClearCommercialGeo();
    }

    const suitableBuildingType = getSuitableBuildingType(type, buildingType, buildingTypes, searchConfig);

    updateBuildingType(suitableBuildingType);
  };
}

export function mapStateToProps(state: IApplicationState): IStoreProps {
  return {
    type: state.type,
    buildingType: state.buildingType.buildingType,
  };
}

export function mapDispatchToProps(dispatch: TDispatch): IDispatchProps {
  return {
    onClearCommercialGeo: () => dispatch(clearCommercialGeo() as any),
    updateBuildingType: (buildingType: string[]) => dispatch(updateBuildingType(buildingType) as any),
    setDirty: (isDirty: boolean) => dispatch(setDirty(isDirty) as any),
    setSearchType: (searchType: SearchType) => dispatch(setSearchType(searchType) as any),
  };
}

const TypeFilter = connect<IStoreProps, IDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(TypeFilterClass);

export { TypeFilter, TypeFilterClass };
